// src/modules/kit_digital/app/SendKitDigitalToHubspot.ts
import { KitDigital } from "@/modules/kit_digital/domain/KitDigital"
import { KitDigitalSenderInterface } from "./KitDigitalSenderInterface"

class SendKitDigitalToHubspot {
  readonly kit: KitDigital
  readonly sender: KitDigitalSenderInterface

  constructor(kit: KitDigital, sender: KitDigitalSenderInterface) {
    this.kit = kit
    this.sender = sender
  }

  async execute() {
    this.kit.setLoading(true)
    try {
      const validatedPath = KitDigital.validatePath(this.kit.keyPath)
      return await this.sender.send(validatedPath)
    } finally {
      this.kit.setLoading(false)
    }
  }
}

export { SendKitDigitalToHubspot }